<div class="row page-title">
  <span>{{ localizationConstants.FIELD_SERVICE_PAGE_TITLE | translate }}</span>
</div>
<div
  *ngIf="!dataSource.data?.length"
  class="row center">
  <div class="col">
    <h2>{{ "fieldservice.norecordsfound" | translate }}</h2>
  </div>
</div>
<section
  [hidden]="!dataSource.data?.length"
  id="visits-filter"
  class="row center">
  <div class="container col-12 col-md-8 col-lg-6 tools-filter">
    <div class="o-grid">
      <div class="o-grid__item col-12">
        <ul class="step-timeline">
          <li class="step-timeline__item no-line">
            <div
              id="st-item-1"
              class="step-timeline__button c-clickable c-numeric"
              [class.active]="lastVisitsActive"
              (click)="toggleLastVisits()">
              <div>
                <span>{{ lastVisitsCount }}</span>
              </div>
            </div>
            <div class="step-timeline__title">
              {{ "fieldservice.lastvisits" | translate }}
            </div>
          </li>
          <li class="step-timeline__item">
            <div
              id="st-item-2"
              class="step-timeline__button c-clickable c-numeric"
              [class.active]="plannedVisitsActive"
              (click)="togglePlannedVisits()">
              <div>
                <span>{{ plannedVisitsCount }}</span>
              </div>
            </div>
            <div class="step-timeline__title">
              {{ "fieldservice.plannedvisits" | translate }}
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
<div
  [hidden]="!dataSource.data?.length"
  class="row u-mb-3">
  <div class="col">
    <div class="o-grid--small between u-align-center">
      <div class="o-grid__item col-6 col-sm-6 col-md-3 u-mb--medium">
        <form class="c-search-form--full">
          <div class="c-input-group">
            <input
              type="text"
              name="search"
              id="input-search"
              [(ngModel)]="dataSource.filter"
              class="c-input c-input--beta"
              placeholder="{{ localizationConstants.QUICK_GRID_FILTER_SEARCH | translate }}"
              required />
            <input
              *ngIf="dataSource.filter"
              id="fs-jobs-search-clear"
              (click)="dataSource.filter = ''"
              class="c-button c-button--search c-close-search c-button--search--sm"
              value="Clear" />
            <input
              *ngIf="!dataSource.filter"
              id="fs-jobs-search"
              type="submit"
              class="c-button c-button--search c-button--search--sm"
              value="Search" />
          </div>
        </form>
      </div>
      <div class="o-grid__item">
        <tool-export-button
          [excelExportType]="ExcelExportType.FieldService"
          [toolFilter]="toolFilter"></tool-export-button>
      </div>
    </div>
    <div class="u-scroll--horizontal">
      <div class="col">
        <table
          mat-table
          [dataSource]="dataSource"
          matSort
          class="c-table">
          <ng-container
            *ngFor="let col of columns"
            [matColumnDef]="col.key">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              class="c-table__column-title">
              {{ col.title | translate }}
            </th>
            <td
              mat-cell
              *matCellDef="let fsJob"
              class="c-clickable"
              [routerLink]="[
                routeNameConstants.FIELD_SERVICE_BASE,
                fsJob.status.toLowerCase(),
                fsJob.companyId,
                fsJob.fsNumber,
              ]">
              <ng-container [ngSwitch]="col.key">
                <div *ngSwitchCase="'fsNumber'">
                  {{ fsJob[col.key] }}
                </div>
                <div *ngSwitchCase="'date'">
                  {{ fsJob[col.key] | date }}
                </div>
                <div *ngSwitchCase="'reason'">
                  {{ fsJob[col.key] | titlecase }}
                </div>
                <div *ngSwitchCase="'contactPerson'">
                  {{ fsJob[col.key] | titlecase }}
                </div>
                <div *ngSwitchCase="'employee'">
                  {{ fsJob[col.key] | titlecase }}
                </div>
                <div *ngSwitchCase="'status'">
                  {{
                    (fsJob.status === "Planned"
                      ? "fieldservice.statusplanned"
                      : "fieldservice.statuslast"
                    ) | translate
                  }}
                </div>
              </ng-container>
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="columnKeys"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: columnKeys"
            class="c-table__row"></tr>
        </table>
      </div>
    </div>
    <div class="c-pagination--desktop">
      <div class="col-12">
        <mat-paginator
          [showFirstLastButtons]="true"
          [pageSize]="pageSize"
          [pageSizeOptions]="[10, 50, 100]"></mat-paginator>
      </div>
    </div>
  </div>
</div>
